module.exports = __webpack_public_path__ + "static/img/adoption_movie_thum_02_no_btn.134fc00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/movie/adoption_movie_thum_02_no_btn.jpg
// module id = eQBF
// module chunks = 0